var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('reward-customer-query',{directives:[{name:"show",rawName:"v-show",value:(_vm.action === 'query'),expression:"action === 'query'"}],on:{"change-action":_vm.changeAction}}),_vm._v(" "),(_vm.action === 'batch')?_c('reward-customer-import',{attrs:{"batch-num":_vm.batchNum},on:{"change-action":_vm.changeAction}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ed8b3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/reward-policy/reward-customer.vue
// module id = null
// module chunks = 